import { ref, computed } from "vue";
import { apiWeeklyArticleRelease, apiWeeklyModularList, apiWeeklyArticleCountry, apiRecipientGroupAll } from "@/request/api";

export default ({ query }) => {
    const modulars = ref([]); // 板块
    const releaseList = ref([]); // 文章发布人列表(来源)
    const modularKeywordList = computed(() => {
        if (!query.tagId) {
            let res = [];
            modulars.value.forEach((item) => {
                if (item.extraKeywords) {
                    res = res.concat(item.extraKeywords.split("|"));
                }
            });
            return [...new Set(res)];
        }
        const modular = modulars.value.find((item) => item.tagId === query.tagId);
        if (modular?.extraKeywords) {
            return modular.extraKeywords.split("|");
        } else {
            return [];
        }
    });
    const countryDict = ref([]); // 国家
    const groupDict = ref([]); // 收件人字典

    // 获取板块
    async function setModulars() {
        const { data } = await apiWeeklyModularList();
        modulars.value = data || [];
    }

    // 获取文章发布人列表
    async function getReleaseList() {
        const { data } = await apiWeeklyArticleRelease();
        releaseList.value = data || [];
    }

    // 国家
    async function getCountryDict() {
        const { data } = await apiWeeklyArticleCountry();
        countryDict.value = data || [];
    }

    // 收件人字典
    async function setGroupDict() {
        const { data } = await apiRecipientGroupAll();
        groupDict.value = data || [];
        groupDict.value = groupDict.value.map((first) => {
            first.id = first.groupId;
            first.name = first.groupName;
            if (first.recipientList?.length) {
                first.recipientList = first.recipientList.map((second) => {
                    second.id = second.id;
                    second.name = second.recipientName;
                    return second;
                });
            }
            return first;
        });
    }

    setModulars();
    getReleaseList();
    getCountryDict();
    setGroupDict();

    return { modulars, modularKeywordList, releaseList, countryDict, groupDict };
};
